export default __webpack_public_path__ + "static/media/foodlogo.af780eea.svg";